import {Component, ViewChild} from '@angular/core';
import {KENDO_DROPDOWNS} from '@progress/kendo-angular-dropdowns';
import {KENDO_INPUTS} from '@progress/kendo-angular-inputs';
import {TranslocoPipe} from '@jsverse/transloco';

import {BoiteDialogueGeneriqueComponent, ControleConteneurComponent, SimplePanelComponent} from '../../../../../../val-ammon-composants/val-composants-lib/src/public-api';
import {AeFDonneesMotif, AeFDonneesStatutFactureAchat} from '../../../../../../val-ammon-services/val-services-efact-lib/src/public-api';

//Composant de sélection d’un statut pour des factures d’achat
@Component (
{
  selector: 'val-selection-statut-facture-achat-edition',
  imports: 
  [
    KENDO_INPUTS,
    KENDO_DROPDOWNS,
    BoiteDialogueGeneriqueComponent,
    SimplePanelComponent,
    ControleConteneurComponent,
    TranslocoPipe
  ],
  templateUrl: './selection-statut-facture-achat-edition.component.html',
  styleUrl: './selection-statut-facture-achat-edition.component.scss',
})
export class SelectionStatutFactureAchatEditionComponent 
{
  //Création
  constructor () 
  {
    this.donnees = new DonneesSelectionStatutFactureAchat ();
    this.tailleLabels = 40;
    this.statuts = [];
    this.statutSelectionne = null;
    this.motifSelectionne = null;
    this.motifDesactive = false;
  }

  //Boîte de dialogue
  @ViewChild ("boiteDialogue")
  public boiteDialogue!: BoiteDialogueGeneriqueComponent<DonneesSelectionStatutFactureAchat>;

  //Données d’édition
  public donnees: DonneesSelectionStatutFactureAchat;

  //Taille des labels
  public tailleLabels: number;

  //Statuts
  public statuts: AeFDonneesStatutFactureAchat[];

  //Statut sélectionné
  public statutSelectionne: AeFDonneesStatutFactureAchat | null;

  //Motif sélectionné
  public motifSelectionne: AeFDonneesMotif | null;
  
  //Indique si les motifs sont désactivés
  public motifDesactive: boolean;

  //Ouvre la boîte de dialogue
  //  Retourne
  //    Données de sélection d’un statut pour des factures d’achat
  public async Ouvrir () : Promise<DonneesSelectionStatutFactureAchat> 
  {
    let operation: Promise<DonneesSelectionStatutFactureAchat>;

    this.donnees.valide = false;
    this.donnees.note = "";
    this.statutSelectionne = null;
    this.motifSelectionne = null;
    this.motifDesactive = true;

    operation = this.boiteDialogue.Ouvrir ();

    return operation;
  }

  //Valide l’édition
  public async Valider () : Promise<void> 
  {
    this.donnees.valide = true;
    this.donnees.identifiantStatut = this.statutSelectionne!.identifiant;
    this.donnees.codeStatut = this.statutSelectionne!.code;

    if (this.motifDesactive)
    {
      this.donnees.identifiantMotif = null;
      this.donnees.codeMotif = null;
    }
    else
    {
      this.donnees.identifiantMotif = this.motifSelectionne!.identifiant;
      this.donnees.codeMotif = this.motifSelectionne!.code;
    }

    this.boiteDialogue.fonctionRetour (this.donnees);
    this.boiteDialogue.Fermer ();
  }

  //Annule l’édition
  public async Annuler () : Promise<void> 
  {
    this.donnees.valide = false;

    this.boiteDialogue.fonctionRetour (this.donnees);
    this.boiteDialogue.Fermer ();
  }

  //Changement de sélection de statut
  //  Paramètres
  //    valeur : Valeur sélectionné
  public SelectionStatutChange (valeur: any) : void 
  {
    let motif: AeFDonneesMotif | null;

    if (this.motifSelectionne && this.statutSelectionne)
    {
      this.motifSelectionne = (valeur as AeFDonneesStatutFactureAchat).motifs.find (mot => mot.identifiant === this.motifSelectionne!.identifiant) ?? null;
    }

    this.motifDesactive = valeur.motifs.length === 0;
  }
}

//Représente les données de sélection d’un statut pour des factures d’achat
export class DonneesSelectionStatutFactureAchat 
{
  //Création
  constructor () 
  {
    this.valide = false;
    this.identifiantStatut = "";
    this.codeStatut = "";
    this.identifiantMotif = null;
    this.codeMotif = null;
    this.note = "";
  }

  //Indique si validé
  public valide: boolean;

  //Identifiant du statut
  public identifiantStatut: string;

  //Code du statut
  public codeStatut: string;

  //Identifiant motif
  public identifiantMotif: string | null;

  //Code du motif
  public codeMotif: string | null;

  //Note
  public note: string;
}
